import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_SK.json';
import guides from './MEDITATION_GUIDES_SK.json';

export const MEDITATION_DATA_SK: ServiceData = {
  audios,
  guides,
};
